import React from "react"
import { useCurrentLocale } from "../../../../../../packages/localization/client-side/useLocalize"
import { Color, useRedoitTheme } from "../../theme"

export function VippsButton({ onClick }: { onClick: () => void }) {
    const locale = useCurrentLocale()
    return React.createElement("vipps-mobilepay-button", {
        style: { width: "100%" },
        onClick,
        type: "button",
        brand: "vipps",
        language: locale.valueOf(),
        variant: "primary",
        rounded: "true",
        verb: "register",
        stretched: "true",
        branded: "true",
    })
}

export function VippsLogo({
    width = 128,
    height = 32,
    color = "vippsOrange",
}: {
    width?: number
    height?: number
    color?: Color
}) {
    const { colors } = useRedoitTheme()

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 64 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                d="M64 3.83839C63.2798 1.09068 61.5314 0 59.1447 0C57.2111 0 54.7842 1.09068 54.7842 3.71715C54.7842 5.41401 55.9565 6.7476 57.8694 7.09117L59.6797 7.41418C60.9141 7.63629 61.2639 8.1011 61.2639 8.72741C61.2639 9.43447 60.5027 9.83844 59.3713 9.83844C57.8904 9.83844 56.9646 9.31324 56.8205 7.83828L54.2081 8.24247C54.6193 11.0908 57.17 12.2629 59.4739 12.2629C61.6547 12.2629 63.9792 11.0101 63.9792 8.48494C63.9792 6.76751 62.9298 5.51533 60.9756 5.15119L58.9805 4.78792C57.8694 4.58593 57.4993 4.04038 57.4993 3.51517C57.4993 2.84837 58.2191 2.42449 59.2066 2.42449C60.4616 2.42449 61.3461 2.84837 61.3872 4.24236L64 3.83839ZM5.925 8.16128L8.6399 0.302869H11.8283L7.09686 11.9594H4.73146L0 0.303088H3.18843L5.925 8.16128ZM22.6084 3.6364C22.6084 4.56558 21.8678 5.21202 21.0037 5.21202C20.1397 5.21202 19.3994 4.56558 19.3994 3.6364C19.3994 2.70701 20.1397 2.06078 21.0037 2.06078C21.8678 2.06078 22.6086 2.70701 22.6086 3.6364H22.6084ZM23.102 7.75775C22.0321 9.13111 20.9007 10.0806 18.9053 10.0807C16.8693 10.0807 15.2849 8.86856 14.0507 7.09095C13.5568 6.36354 12.7957 6.20204 12.2402 6.58588C11.726 6.94959 11.6028 7.71726 12.0757 8.38406C13.783 10.9497 16.1486 12.4443 18.9051 12.4443C21.4356 12.4443 23.4106 11.2324 24.9532 9.21213C25.5291 8.46481 25.5085 7.69713 24.9532 7.27281C24.4388 6.8684 23.6777 7.01042 23.102 7.75775ZM30.2 6.10094C30.2 8.48494 31.5989 9.73756 33.1625 9.73756C34.6434 9.73756 36.1659 8.56569 36.1659 6.10094C36.1659 3.67645 34.6434 2.50502 33.1828 2.50502C31.5989 2.50502 30.2 3.61605 30.2 6.10094ZM30.2 1.91941V0.323002H27.2996V16H30.2V10.424C31.1669 11.7172 32.4217 12.2629 33.8409 12.2629C36.495 12.2629 39.0868 10.2021 39.0868 5.95979C39.0868 1.89884 36.392 0.000218836 34.0879 0.000218836C32.257 0.000218836 31.0024 0.828296 30.2 1.91941ZM44.1275 6.10094C44.1275 8.48494 45.5262 9.73756 47.0898 9.73756C48.5707 9.73756 50.093 8.56569 50.093 6.10094C50.093 3.67645 48.5707 2.50502 47.1102 2.50502C45.5262 2.50502 44.1273 3.61605 44.1273 6.10094H44.1275ZM44.1275 1.91941V0.323002H44.1273H41.2269V16H44.1273V10.424C45.0943 11.7172 46.349 12.2629 47.7683 12.2629C50.4222 12.2629 53.0142 10.2021 53.0142 5.95979C53.0142 1.89884 50.3194 0.000218836 48.0152 0.000218836C46.1843 0.000218836 44.9298 0.828296 44.1275 1.91941Z"
                fill={colors[color]}
            />
        </svg>
    )
}
